import { useState, useCallback } from 'react';

export function useDrawerSelection<T>(value: T) {
  const [localSelection, setLocalSelection] = useState<T>(value);

  const handleOpenChange = useCallback(
    (open: boolean) => {
      if (!open) setLocalSelection(value);
    },
    [value],
  );

  const handleSelect = useCallback(
    (newValue: T) => setLocalSelection(newValue),
    [],
  );

  return {
    localSelection,
    setLocalSelection,
    handleOpenChange,
    handleSelect,
  };
}
